var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tfoot',[_c('tr',_vm._l((_vm.options.columns),function(c){return _c('td',{key:c.key,class:_vm.options.classes.tf},[_vm._t('foot(' + c.key + ')',function(){return [_vm._t("foot",function(){return [_vm._v(_vm._s(c.title))]},{"column":c})]},{"column":c})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }